/* global HSCore */

import React, { useContext, useEffect, useRef, useState } from "react";
import LanguageContext from "../../../utils/Contexts/LanguageContext";
import ThemeContext from "../../../utils/Contexts/ThemeContext";
import Constant from "../../Constants";
import UserContext from "../../../utils/Contexts/UserContext";
import toast from "react-hot-toast";
import axiosInstance from "../../../utils/Requests/axios";

function Notification() {
  const { t } = useContext(LanguageContext);
  const { selectedTheme } = useContext(ThemeContext);
  const { userData } = useContext(UserContext);
  const { themeStatus } = Constant();
  const [notifications, setNotifications] = useState({
    notify_necessary: true,
    notify_essential: false,
    notify_helpful: false,
    notify_weekly: false,
    notify_marketing: false,
  });

  const fetchNotifications = async () => {
    const url = `settings/users/${userData?.uuid}/profile/notifications`;
    axiosInstance
      .get(url)
      .then((response) => {
        setNotifications(response.data);
      })
      .catch((error) => {
        console.log(error);
        toast.error(t("Error fetching notifications!"));
      });
  };

  const handleToggle = (key) => {
    const updated = {
      ...notifications,
      [key]: !notifications[key],
    };
    setNotifications(updated);

    const {
      notify_essential,
      notify_helpful,
      notify_weekly,
      notify_marketing,
    } = updated;

    if (!userData?.uuid) return;

    const payload = {
      notify_essential,
      notify_helpful,
      notify_weekly,
      notify_marketing,
    };

    axiosInstance
      .put(`settings/users/${userData.uuid}/profile/notifications`, payload)
      .then(() => {
        toast.success(t("Notifications updated!"));
      })
      .catch((error) => {
        console.error("Error updating notifications:", error);
        toast.error(t("Failed to update notifications"));
      });
  };

  const notificationDataFetched = useRef(false);
  useEffect(() => {
    if (notificationDataFetched.current) return;
    notificationDataFetched.current = true;
    fetchNotifications();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const jsSelectInitRef = useRef(null);
  useEffect(() => {
    if (!jsSelectInitRef.current) {
      HSCore.components.HSTomSelect.init(".js-select-notification");
      // eslint-disable-next-line react-hooks/exhaustive-deps
      jsSelectInitRef.current = true;
    }
  }, []);

  return (
    <div
      id="Notification"
      className={`card cardSetting ${themeStatus?.[selectedTheme]}`}
    >
      <div className="card-header">
        <h4
          className="card-title responsive-title"
          style={{ fontWeight: "700" }}
        >
          {t("Notification")}
        </h4>
      </div>

      <div className="card-body pb-0">
        <label
          className="form-check-label card-text mb-2"
          style={{ color: "var(--text-email)" }}
        >
          {t("Get notifications via email")}
        </label>
        <div className="tom-select-custom tom-select-custom-end tom-select-custom-bg-transparent">
          <select
            className="js-select-notification form-select form-select-sm card-text"
            data-hs-tom-select-options='{
                        "searchInDropdown": false,
                        "hideSearch": true,
                        "dropdownWidth": "100%"
                      }'
            id="tomselect-2"
          >
            <option>{t("About every event")}</option>
          </select>
        </div>
      </div>

      <div className="card-body pb-1">
        <form>
          <div className="list-group list-group-lg list-group-flush list-group-no-gutters">
            <div className="list-group-item py-3">
              <div className="d-flex align-items-center">
                <div className="flex-grow-1">
                  <div className="row align-items-center">
                    <div className="col">
                      <h5
                        className="mb-2"
                        style={{
                          fontSize: "16px",
                          fontWeight: "600",
                          color: "var(--whiteToBlack)",
                        }}
                      >
                        {t("Strictly necessary letters")}
                      </h5>
                      <p
                        className="mb-0"
                        style={{
                          fontSize: "14px",
                          fontWeight: "400",
                          color: "rgba(145, 146, 147, 1)",
                        }}
                      >
                        {t(
                          "Letters related to the email change, password change, email verification. You cannot unsubscribe from these letters as long as you use BacklinksFactory."
                        )}
                      </p>
                    </div>

                    <div className="col-auto">
                      <div className="form-check form-switch">
                        <input
                          className="form-check-input me-0"
                          type="checkbox"
                          style={{
                            width: "51px",
                            height: "25px",
                            backgroundColor: notifications.notify_necessary
                              ? "rgba(56, 124, 255, 1)"
                              : "var(--toggle-color)",
                          }}
                          id="connectedAccounts1"
                          checked={notifications.notify_necessary}
                          disabled={true}
                        />
                        <label
                          className="form-check-label"
                          htmlFor="connectedAccounts1"
                        ></label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="list-group-item py-3">
              <div className="d-flex align-items-center">
                <div className="flex-grow-1">
                  <div className="row align-items-center">
                    <div className="col">
                      <h5
                        className="mb-2"
                        style={{
                          fontSize: "16px",
                          fontWeight: "600",
                          color: "var(--whiteToBlack)",
                        }}
                      >
                        {t("Essential letters")}
                      </h5>
                      <div className="d-flex flex-wrap gap-1 align-items-center">
                        <p
                          className="mb-1"
                          style={{
                            fontSize: "14px",
                            fontWeight: "400",
                            color: "rgba(145, 146, 147, 1)",
                          }}
                        >
                          {t(
                            "Letters about everything related to your tasks and order at BacklinksFactory. We highly recommend you to stay subscribed to these letters as they reflect the gist of your cooperation with BacklinksFactory."
                          )}
                        </p>
                      </div>
                    </div>

                    <div className="col-auto">
                      <div className="form-check form-switch">
                        <input
                          className="form-check-input me-0"
                          type="checkbox"
                          style={{
                            width: "51px",
                            height: "25px",
                            backgroundColor: notifications.notify_essential
                              ? "rgba(56, 124, 255, 1)"
                              : "var(--toggle-color)",
                          }}
                          id="connectedAccounts2"
                          checked={notifications.notify_essential}
                          onChange={() => handleToggle("notify_essential")}
                        />
                        <label
                          className="form-check-label"
                          htmlFor="connectedAccounts2"
                        ></label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="list-group-item py-3">
              <div className="d-flex align-items-center">
                <div className="flex-grow-1">
                  <div className="row align-items-center">
                    <div className="col">
                      <h5
                        className="mb-2"
                        style={{
                          fontSize: "16px",
                          fontWeight: "600",
                          color: "var(--whiteToBlack)",
                        }}
                      >
                        {t("Helpful letters")}
                      </h5>
                      <div className="d-flex flex-wrap gap-1 align-items-center">
                        <p
                          className="mb-1"
                          style={{
                            fontSize: "14px",
                            fontWeight: "400",
                            color: "rgba(145, 146, 147, 1)",
                          }}
                        >
                          {t(
                            "While not so important as the essential letters, these letters may still be of service to you. Keep them on if you do not want to miss any event or opportunity from your BacklinksFactory account."
                          )}
                        </p>
                      </div>
                    </div>

                    <div className="col-auto">
                      <div className="form-check form-switch">
                        <input
                          className="form-check-input me-0"
                          type="checkbox"
                          style={{
                            width: "51px",
                            height: "25px",
                            backgroundColor: notifications.notify_helpful
                              ? "rgba(56, 124, 255, 1)"
                              : "var(--toggle-color)",
                          }}
                          id="connectedAccounts2"
                          checked={notifications.notify_helpful}
                          onChange={() => handleToggle("notify_helpful")}
                        />
                        <label
                          className="form-check-label"
                          htmlFor="connectedAccounts2"
                        ></label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="list-group-item py-3">
              <div className="d-flex align-items-center">
                <div className="flex-grow-1">
                  <div className="row align-items-center">
                    <div className="col">
                      <h5
                        className="mb-2"
                        style={{
                          fontSize: "16px",
                          fontWeight: "600",
                          color: "var(--whiteToBlack)",
                        }}
                      >
                        {t("Weekly updates")}
                      </h5>
                      <div className="d-flex flex-wrap gap-1 align-items-center">
                        <p
                          className="mb-1"
                          style={{
                            fontSize: "14px",
                            fontWeight: "400",
                            color: "rgba(145, 146, 147, 1)",
                          }}
                        >
                          {t(
                            "Letters about new sites added to the BacklinksFactory inventory, sent on a weekly basis to buyers only."
                          )}
                        </p>
                      </div>
                    </div>

                    <div className="col-auto">
                      <div className="form-check form-switch">
                        <input
                          className="form-check-input me-0"
                          type="checkbox"
                          style={{
                            width: "51px",
                            height: "25px",
                            backgroundColor: notifications.notify_weekly
                              ? "rgba(56, 124, 255, 1)"
                              : "var(--toggle-color)",
                          }}
                          id="connectedAccounts2"
                          checked={notifications.notify_weekly}
                          onChange={() => handleToggle("notify_weekly")}
                        />
                        <label
                          className="form-check-label"
                          htmlFor="connectedAccounts2"
                        ></label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="list-group-item py-3">
              <div className="d-flex align-items-center">
                <div className="flex-grow-1">
                  <div className="row align-items-center">
                    <div className="col">
                      <h5
                        className="mb-2"
                        style={{
                          fontSize: "16px",
                          fontWeight: "600",
                          color: "var(--whiteToBlack)",
                        }}
                      >
                        {t("Marketing letters")}
                      </h5>
                      <div className="d-flex flex-wrap gap-1 align-items-center">
                        <p
                          className="mb-1"
                          style={{
                            fontSize: "14px",
                            fontWeight: "400",
                            color: "rgba(145, 146, 147, 1)",
                          }}
                        >
                          {t(
                            "Helpful tips on how to work with BacklinksFactory, notifications about our promo events and bonuses, useful information focused on search engine optimization and digital marketing, etc."
                          )}
                        </p>
                      </div>
                    </div>

                    <div className="col-auto">
                      <div className="form-check form-switch">
                        <input
                          className="form-check-input me-0"
                          type="checkbox"
                          style={{
                            width: "51px",
                            height: "25px",
                            backgroundColor: notifications?.notify_marketing
                              ? "rgba(56, 124, 255, 1)"
                              : "var(--toggle-color)",
                          }}
                          id="connectedAccounts2"
                          checked={notifications.notify_marketing}
                          onChange={() => handleToggle("notify_marketing")}
                        />
                        <label
                          className="form-check-label"
                          htmlFor="connectedAccounts2"
                        ></label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}

export default Notification;
